import React from 'react';
import { Settings } from '~/templates/pages';

export const SettingsContext = React.createContext<Settings>({} as Settings);
